export type TQmulusDropdownVariant = 'single' | 'multi' | 'filter';

export type TNamedOption<OPTION> = {
  value: OPTION,
  displayName: string,
};
export type TOption<OPTION> = OPTION | TNamedOption<OPTION>;

export function isNamedOption<OPTION>(option: TOption<OPTION>): option is TNamedOption<OPTION> {
  return typeof option === 'object'
    && option !== null
    && 'displayName' in option
    && 'value' in option;
}

type TIsClearable<CLEARABLE extends boolean> = true extends CLEARABLE ? true : false;
type TIsSingle<VARIANT extends TQmulusDropdownVariant> = VARIANT extends 'single' ? true : false;
type TClearedValue<VARIANT extends TQmulusDropdownVariant, CLEARABLE extends boolean> = [TIsClearable<CLEARABLE>, TIsSingle<VARIANT>] extends [true, true] ? undefined : never;

export type TClearableModelValue<MODEL_VALUE, VARIANT extends TQmulusDropdownVariant, CLEARABLE extends boolean> = MODEL_VALUE | TClearedValue<VARIANT, CLEARABLE>;

export function isShowClearEnabled(showClear: boolean | '' | undefined): boolean {
  return showClear === true || showClear === '';
}

/**
 * Normalizes the empty value PrimeVue emits (`null`), so a cleared selection always reaches the consumer:
 * a single dropdown emits `undefined`, a multi dropdown `[]`.
 */
export function normalizeEmptyModelValue<VALUE>(
  value: VALUE | null | undefined,
  variant: TQmulusDropdownVariant,
): VALUE | VALUE[] | undefined {
  if (value !== null && value !== undefined) {
    return value;
  }
  return variant === 'single' ? undefined : [];
}
